// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gefgcarkzczsuxczmfxd.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdlZmdjYXJremN6c3V4Y3ptZnhkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQyOTUyODYsImV4cCI6MjA1OTg3MTI4Nn0.8kdrPilokOHF1OnNscvtgd3oPizGgvw1ucxO7dXDKJY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);